import { clearNativeContactData, clearNativeLocalProfileKeyMaterial, nativeChatStorage } from './webviewBridge';

const KNOWN_INDEXED_DB_NAMES = [
  'family-messenger',
  'family-messenger-messages',
  'family-messenger-group-chats',
  'family-messenger-call-history',
  'family-messenger-direct-chat-keys',
  'family-messenger-direct-files',
  'family-messenger-chat-attachments',
  'family-messenger-history-secrets',
  'family-messenger-system-events',
  'family-messenger-message-archive',
  'family-messenger-message-archive-keys'
];

function deleteIndexedDb(name: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(name);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
    request.onblocked = () => resolve();
  });
}

async function listKnownIndexedDbNames(): Promise<string[]> {
  const dbFactory = indexedDB as IDBFactory & {
    databases?: () => Promise<Array<{ name?: string | null }>>;
  };

  if (!dbFactory.databases) return KNOWN_INDEXED_DB_NAMES;

  try {
    const databases = await dbFactory.databases();
    const discovered = databases
      .map((db) => db.name || '')
      .filter((name) => name.startsWith('family-messenger'));
    return Array.from(new Set([...KNOWN_INDEXED_DB_NAMES, ...discovered]));
  } catch {
    return KNOWN_INDEXED_DB_NAMES;
  }
}

export async function clearLocalBrowserProfile(): Promise<void> {
  nativeChatStorage.clearLocalProfileData();
  clearNativeLocalProfileKeyMaterial();
  clearNativeContactData();

  const dbNames = await listKnownIndexedDbNames();
  await Promise.allSettled(dbNames.map((name) => deleteIndexedDb(name)));

  try {
    localStorage.clear();
  } catch {
    // ignore
  }

  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.allSettled(cacheNames.map((name) => caches.delete(name)));
  }
}
